import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_catalogo, origen_recurso } from '../../../../../../Constants/Constants';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';
import OrigenRecJson from '../../../../../Datos/TipoOrigenRec.json';

const OrigenRecurso = ({ id, permisos }) => {
    const [ origenRecursos, setOrigenRecursos ] = useState( null );
    useEffect(() => {
        axiosOrigenRecursos();
    }, []);

    const axiosOrigenRecursos = () => {
        /*axios.get( `${servicios_grupogack_catalogo}/origenrecurso/`, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:*/
                        setOrigenRecursos( OrigenRecJson );
                        /*break;
                    case 404:
                        //setOrigenRecursos([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })*/
    }

    return (
        <div id={ id }>
            { origenRecursos ?
                <DataTableService id={id} title={ origen_recurso } permisos={permisos}
                    columns={[
                        { field: "origenRecClave", title: "Clave" },
                        { field: "origenRecDesc", title: "Descripción" },
                    ]}
                    data={ origenRecursos } /> : <SpinnerOval />
            }
        </div>
    );
};

export default OrigenRecurso;